/* eslint-disable operator-linebreak */
import cookies from '../cookies'
import getCurrentDomain from '../getCurrentDomain'
import getEnv from '../env'

const cookieOptions = (req) => {
  const domain = getCurrentDomain(req?.headers?.host)
  return { domain }
}

const getQaCookies = (ctx = null) => {
  const env = getEnv()
  if (env === 'production') {
    return null
  }
  const tpPrefix = cookies.get('tpPrefix', ctx?.req)
  const clearCache =
    cookies.get('clearCache', ctx?.req) === null
      ? null
      : cookies.get('clearCache', ctx?.req) === 'true'
  return {
    ...(tpPrefix && { tpPrefix }),
    ...(clearCache !== null && { clearCache }),
  }
}

export const setQaCookies = (ctx = null, settings) => {
  Object.keys(settings).forEach((key) => {
    if (typeof settings[key] !== 'undefined' && settings[key] !== null) {
      cookies.set(key, settings[key], cookieOptions(ctx?.req), ctx?.res)
    }
  })
}

export const clearQaCookies = (keys) => {
  keys.forEach((key) => {
    cookies.remove(key, cookieOptions())
  })
}

export default getQaCookies
